import { render, staticRenderFns } from "./ReportEducationChart.vue?vue&type=template&id=5a564ea1"
import script from "./ReportEducationChart.vue?vue&type=script&lang=ts"
export * from "./ReportEducationChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports